import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'src/classnames';
import { ArrowForwardIos } from '@mui/icons-material';
import NextLink from '../NextLink';
import { colors } from '../../constants/styleConstants';
import styles from './GoToLink.module.scss';

const GoToLink = ({ linkText, linkProps, size, color, icon, weight }) => {
  const arrowStyles = useMemo(() => ({ fontSize: 12, color: colors[color] }), [color]);
  return (
    <NextLink className={styles.linkBox} {...linkProps}>
      <div className={styles.link}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <span
          className={cx(styles.linkText, {
            [styles.medium]: size === 'medium',
            [styles.large]: size === 'large',
            [styles.blue]: color === 'blue',
            [styles.white]: color === 'white',
            [styles.bold]: weight === 'bold',
          })}
        >
          {linkText}
        </span>
      </div>
      <ArrowForwardIos style={arrowStyles} />
    </NextLink>
  );
};

GoToLink.propTypes = {
  linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
  linkText: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  icon: PropTypes.node,
};

export default GoToLink;
